import type { HTMLAttributes, ReactNode } from 'react';
import './Card.css';

type CardVariant = 'stacked' | 'row' | 'compact';

export type CardProps = HTMLAttributes<HTMLDivElement> & {
    variant?: CardVariant;
    interactive?: boolean;
    as?: 'div' | 'button';
    children: ReactNode;
};

type SlotProps = { children: ReactNode; className?: string };

function Card({
    variant = 'stacked',
    interactive = false,
    className = '',
    children,
    ...rest
}: CardProps) {
    const classes = [
        'ui-card',
        `ui-card--${variant}`,
        interactive ? 'ui-card--interactive' : '',
        className,
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <div className={classes} {...rest}>
            {children}
        </div>
    );
}

Card.Media = ({ children, className = '' }: SlotProps) => (
    <div className={`ui-card__media ${className}`.trim()}>{children}</div>
);

Card.Header = ({ children, className = '' }: SlotProps) => (
    <div className={`ui-card__header ${className}`.trim()}>{children}</div>
);

Card.Body = ({ children, className = '' }: SlotProps) => (
    <div className={`ui-card__body ${className}`.trim()}>{children}</div>
);

Card.Footer = ({ children, className = '' }: SlotProps) => (
    <div className={`ui-card__footer ${className}`.trim()}>{children}</div>
);

export default Card;
